import { faArrowUp, faCheck, faEdit, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { CompactPicker } from 'react-color';
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';
import {
    Alert,
    Button,
    ButtonGroup,
    Col,
    ControlLabel,
    FlexboxGrid,
    Form,
    FormControl,
    FormGroup,
    Input,
    Modal,
    Panel,
    SelectPicker,
    Toggle,
} from 'rsuite';
import { LPDisplay } from '../../../../../../../handlers/lpDisplays/LPDisplay';
import { VirtualDisplayPreviewInformation } from '../../../../../../../handlers/lpDisplays/VirtualDisplay';
import { VirtualDisplayStep } from '../../../../../../../handlers/lpDisplays/VirtualDisplayStep';
import { authHeader } from '../../../../../../../redux/helpers';
import { axiosService } from '../../../../../../../redux/services';
import { hexToRgb } from '../../../../../../../utils/colorUtils';
import PanelHeader from '../../../../../../Custom/PanelHeader';
import { EditUserTextModal } from '../../../../../../Map/Components/LPMatrixDisplay/ForceLPMatrixDisplay/FlowChart/Modal/EditUserTextModal';
import { LPMatrixDisplayWidget } from '../../../../Widgets/LPMatrixDisplayWidget';
import {
    LPVirtualDisplayArrow,
    LPVirtualDisplayArrowAnimation,
    LPVirtualDisplayArrowOnMap,
    LPVirtualDisplayMode,
    LPVirtualDisplayPicto,
    LPVirtualDisplayPosition,
    LPVirtualDisplayRGBPicto,
    LPVirtualDisplaySize,
    LPVirtualDisplayStateFormValues,
    LPVirtualDisplayStepColor,
    LPVirtualDisplaySystemText,
    LPVirtualDisplayTextTransformation,
    LPVirtualDisplayTriggerSteps,
    LPVirtualDisplayTriggerType,
    LPVirtualDisplayTriggerVirtualDisplay,
    LPVirtualDisplayUserText,
} from '../../Form/LPVirtualDisplayStepFormValues';

type Props = {
    display: LPDisplay;
    virtualDisplay: VirtualDisplayPreviewInformation;
    show: boolean;
    onHide: Function;
    updateInformation: Function;
} & WrappedComponentProps;

type State = {
    formValue: FormValue;
    isCreating: boolean;
    hasError: boolean;
    previewStep: VirtualDisplayStep;
    editUserTextModalInformation: {
        isOpen: boolean;
        userTextIndex: number;
    };
};

type FormValue = {
    state: number;
    color: string;
    mode: number;
    textTransformation: number;
    transition: number;
    time: number;
    pictoSize: number;
    picto: number;
    pictoPosition: number;
    arrowSize: number;
    arrow: number;
    arrowOnMap: number;
    arrowPosition: number;
    arrowAnimation: number;
    arrowRepeat: boolean;
    text: number;
    userText: number;
    triggerMinType: number;
    triggerMinValue: number;
    triggerMinAction: number;
    triggerMaxType: number;
    triggerMaxValue: number;
    triggerMaxAction: number;
};

class CreateLPVirtualDisplayStepModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isCreating: false,
            hasError: false,
            editUserTextModalInformation: {
                isOpen: false,
                userTextIndex: -1,
            },
            formValue: {
                state: 1,
                color: '#C00000',
                mode: 1,
                textTransformation: 3,
                transition: 0,
                time: 2,
                pictoSize: 16,
                picto: 1,
                pictoPosition: 0,
                arrowSize: 16,
                arrow: 1,
                arrowOnMap: 1,
                arrowPosition: 0,
                arrowAnimation: 10000,
                arrowRepeat: false,
                text: 1,
                userText: 1,
                triggerMinType: -1,
                triggerMinAction: 0,
                triggerMinValue: 100,
                triggerMaxType: -1,
                triggerMaxAction: 0,
                triggerMaxValue: 100,
            },
            previewStep: new VirtualDisplayStep({
                state: 1,
                color: hexToRgb('#C00000'),
                mode: 1,
                textTransformation: 3,
                transition: 0,
                time: 2,
                pictoSize: 16,
                picto: 1,
                arrowSize: 10016,
                arrow: 1,
                arrowOnMap: 1,
                stepOrder: 0,
                triggerMin: {
                    value: 100,
                    action: 0,
                },
                triggerMax: {
                    value: 100,
                    action: 0,
                },
            }),
        };
    }

    handleFormChange = formValue => {
        if (formValue.mode !== 1 && formValue.arrowPosition === 0) formValue.arrowPosition = 1000;
        if (formValue.mode !== 2 && formValue.mode !== 20 && formValue.pictoPosition === 0)
            formValue.pictoPosition = 1000;

        if (formValue.mode === 1 && formValue.arrow === 0) formValue.arrow = 1;
        if ((formValue.mode === 2 || formValue.mode === 20) && formValue.picto === 0) formValue.picto = 1;

        this.state.previewStep.updateVirtualDisplayStep({
            state: parseInt(formValue.state),
            color: hexToRgb(formValue.color),
            mode: parseInt(formValue.mode),
            textTransformation: parseInt(formValue.textTransformation),
            transition: parseInt(formValue.transition),
            time: parseInt(formValue.time),
            pictoSize: parseInt(formValue.pictoSize) + parseInt(formValue.pictoPosition),
            picto: parseInt(formValue.picto),
            arrowSize:
                parseInt(formValue.arrowSize) +
                parseInt(formValue.arrowPosition) +
                parseInt(formValue.arrowAnimation) +
                (formValue.arrowRepeat ? 30000 : 0),
            arrow: parseInt(formValue.arrow),
            arrowOnMap: parseInt(formValue.arrowOnMap),
            stepOrder: 0,
            triggerMin: {
                value: parseInt(formValue.triggerMinValue),
                action: 0,
            },
            triggerMax: {
                value: parseInt(formValue.triggerMaxValue),
                action: 0,
            },
        });

        this.setState({
            formValue: {
                state: parseInt(formValue.state),
                color: formValue.color,
                mode: parseInt(formValue.mode),
                textTransformation: parseInt(formValue.textTransformation),
                transition: parseInt(formValue.transition),
                time: parseInt(formValue.time),
                pictoSize: parseInt(formValue.pictoSize),
                picto: parseInt(formValue.picto),
                pictoPosition: parseInt(formValue.pictoPosition),
                arrowSize: parseInt(formValue.arrowSize),
                arrow: parseInt(formValue.arrow),
                arrowPosition: parseInt(formValue.arrowPosition),
                arrowAnimation: parseInt(formValue.arrowAnimation),
                arrowRepeat: formValue.arrowRepeat,
                arrowOnMap: parseInt(formValue.arrowOnMap),
                text: parseInt(formValue.text),
                userText: parseInt(formValue.userText),
                triggerMinType: parseInt(formValue.triggerMinType),
                triggerMinAction: parseInt(formValue.triggerMinAction),
                triggerMinValue: parseInt(formValue.triggerMinValue),
                triggerMaxAction: parseInt(formValue.triggerMaxAction),
                triggerMaxValue: parseInt(formValue.triggerMaxValue),
                triggerMaxType: parseInt(formValue.triggerMaxType),
            },
        });
    };

    hideModal = (shouldReload: boolean = false) => {
        this.setState({
            isCreating: false,
            hasError: false,
            // formValue: {
            //     state: 1,
            //     color: '#C00000',
            //     mode: 1,
            //     textTransformation: 0,
            //     transition: 0,
            //     time: 5,
            //     pictoSize: 16,
            //     picto: 0,
            //     pictoPosition: 0,
            //     arrowSize: 16,
            //     arrow: 1,
            //     arrowPosition: 0,
            //     arrowAnimation: 0,
            //     text: 1,
            //     userText: 1,
            //     triggerMinType: -1,
            //     triggerMinAction: 0,
            //     triggerMinValue: 100,
            //     triggerMaxType: -1,
            //     triggerMaxAction: 0,
            //     triggerMaxValue: 100,
            // },
        });

        this.props.onHide(shouldReload);
    };

    handleColorChange = color => {
        this.state.previewStep.updateVirtualDisplayStep({
            state: this.state.formValue.state,
            color: { red: color.rgb.r, green: color.rgb.g, blue: color.rgb.b },
            mode: this.state.formValue.mode,
            textTransformation: this.state.formValue.textTransformation,
            transition: this.state.formValue.transition,
            time: this.state.formValue.time,
            pictoSize: this.state.formValue.pictoSize + this.state.formValue.pictoPosition,
            picto: this.state.formValue.picto,
            arrowSize:
                this.state.formValue.arrowSize +
                this.state.formValue.arrowPosition +
                this.state.formValue.arrowAnimation +
                (this.state.formValue.arrowRepeat ? 30000 : 0),
            arrow: this.state.formValue.arrow,
            arrowOnMap: this.state.formValue.arrowOnMap,
            stepOrder: 0,
            triggerMin: {
                value: this.state.formValue.triggerMinValue,
                action: 0,
            },
            triggerMax: {
                value: this.state.formValue.triggerMaxValue,
                action: 0,
            },
        });

        this.setState({
            formValue: {
                ...this.state.formValue,
                color: color.hex.toUpperCase(),
            },
        });
    };

    createStep = () => {
        this.setState({
            isCreating: true,
            hasError: false,
        });

        const {
            state,
            color,
            mode,
            textTransformation,
            transition,
            time,
            pictoSize,
            picto,
            pictoPosition,
            arrowSize,
            arrow,
            arrowPosition,
            arrowAnimation,
            arrowRepeat,
            triggerMinValue,
            triggerMinType,
            triggerMinAction,
            triggerMaxValue,
            triggerMaxType,
            triggerMaxAction,
        } = this.state.formValue;

        const data = {
            state,
            color: hexToRgb(color),
            mode,
            textTransformation,
            transition,
            stepOrder: 0,
            time,
            pictoSize: pictoSize + pictoPosition,
            picto,
            arrowSize: arrowSize + arrowPosition + arrowAnimation + (arrowRepeat ? 30000 : 0),
            arrow,
            triggerMin: {
                value: triggerMinValue,
                action: triggerMinType < 0 ? 0 : triggerMinType + triggerMinAction,
            },
            triggerMax: {
                value: triggerMaxValue,
                action: triggerMaxType < 0 ? 0 : triggerMaxType + triggerMaxAction,
            },
            id_virtualDisplay: this.props.virtualDisplay.id,
        };

        axiosService
            .getAxios()
            .post('/devices/lp-matrixdisplays-v2/virtualDisplay/step', data, {
                headers: authHeader(),
            })
            .then(addVirtualDisplayResponse => {
                Alert.success(
                    this.props.intl.formatMessage({
                        id: 'ipCanDevices.lpDisplay.virtualDisplay.steps.create.success',
                    }),
                    5000
                );

                this.props.updateInformation(addVirtualDisplayResponse.data);

                this.hideModal(true);
            })
            .catch(err => {
                console.error(err);
                Alert.error(
                    this.props.intl.formatMessage(
                        {
                            id: 'ipCanDevices.lpDisplay.virtualDisplay.steps.create.error',
                        },
                        {
                            err,
                        }
                    ),
                    5000
                );

                this.setState({
                    hasError: true,
                });
            })
            .finally(() => {
                this.setState({
                    isCreating: false,
                });
            });
    };

    renderArrowSection = () => (
        <Panel
            className="panel-small"
            shaded
            bordered
            header={
                <PanelHeader
                    title={this.props.intl.formatMessage({
                        id: 'ipCanDevices.lpDisplay.virtualDisplay.steps.create.arrowPart',
                    })}
                    buttons={[]}
                />
            }>
            {/* === ARROW STYLE === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.arrow" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            data-cy="lpDisplay-add-step-arrow"
                            name="arrow"
                            accepter={SelectPicker}
                            data={LPVirtualDisplayArrow(this.props.intl)}
                            renderMenuItem={(label, item: any) => {
                                if (item.value === 0) return label;

                                return (
                                    <FontAwesomeIcon
                                        data-cy={`lpDisplay-add-step-arrow-${item.value}`}
                                        icon={faArrowUp}
                                        transform={{ rotate: item.orientation }}
                                    />
                                );
                            }}
                            renderValue={(value, item: any) => {
                                if (value === 0) return item.label;
                                return <FontAwesomeIcon icon={faArrowUp} transform={{ rotate: item.orientation }} />;
                            }}
                            placement="top"
                            searchable={false}
                            cleanable={false}
                            disabledItemValues={this.state.formValue.mode === 1 ? [0] : []}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>

            {/* === ARROW ON MAP === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.arrow" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            data-cy="lpDisplay-add-step-arrow"
                            name="arrowOnMap"
                            accepter={SelectPicker}
                            data={LPVirtualDisplayArrowOnMap(this.props.intl)}
                            renderMenuItem={(label, item: any) => {
                                if (item.value === 0) return label;

                                return (
                                    <FontAwesomeIcon
                                        data-cy={`lpDisplay-add-step-arrowOnMap-${item.value}`}
                                        icon={faArrowUp}
                                        transform={{ rotate: item.orientation }}
                                    />
                                );
                            }}
                            renderValue={(value, item: any) => {
                                if (value === 0) return item.label;
                                return <FontAwesomeIcon icon={faArrowUp} transform={{ rotate: item.orientation }} />;
                            }}
                            placement="top"
                            searchable={false}
                            cleanable={false}
                            disabledItemValues={[0]}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>

            {/* === ARROW SIZE === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.arrowSize" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            data-cy="lpDisplay-add-step-arrowSize"
                            name="arrowSize"
                            accepter={SelectPicker}
                            data={LPVirtualDisplaySize(this.props.intl)}
                            searchable={false}
                            cleanable={false}
                            placement="top"
                            disabled={this.state.formValue.arrow === 0}
                            renderMenuItem={(label, item) => {
                                return <div data-cy={`lpDisplay-add-step-arrowSize-${item.value}`}>{label}</div>;
                            }}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>

            {/* === ARROW POSITION === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.arrowPosition" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            data-cy="lpDisplay-add-step-arrowPosition"
                            name="arrowPosition"
                            accepter={SelectPicker}
                            data={LPVirtualDisplayPosition(this.props.intl)}
                            searchable={false}
                            cleanable={false}
                            placement="top"
                            disabled={this.state.formValue.arrow === 0}
                            disabledItemValues={this.state.formValue.mode !== 1 ? [0] : []}
                            renderMenuItem={(label, item) => {
                                return <div data-cy={`lpDisplay-add-step-arrowPosition-${item.value}`}>{label}</div>;
                            }}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>

            {/* === ARROW ANIMATION === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.arrowAnimation" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            data-cy="lpDisplay-add-step-arrowAnimation"
                            name="arrowAnimation"
                            accepter={SelectPicker}
                            data={LPVirtualDisplayArrowAnimation(this.props.intl)}
                            searchable={false}
                            cleanable={false}
                            placement="top"
                            disabled={this.state.formValue.arrow === 0}
                            renderMenuItem={(label, item) => {
                                return <div data-cy={`lpDisplay-add-step-arrowAnimation-${item.value}`}>{label}</div>;
                            }}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>

            {/* === ARROW REPEAT === */}
            {this.state.formValue.mode === 1 && (
                <FormGroup>
                    <FlexboxGrid align="middle" justify="space-between">
                        <FlexboxGrid.Item componentClass={Col} xs={10}>
                            <ControlLabel>
                                <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.arrowRepeat" />
                            </ControlLabel>
                        </FlexboxGrid.Item>

                        <FlexboxGrid.Item>
                            <FormControl
                                data-cy="lpDisplay-add-step-arrowRepeat"
                                name="arrowRepeat"
                                accepter={Toggle}
                            />
                        </FlexboxGrid.Item>
                    </FlexboxGrid>
                </FormGroup>
            )}
        </Panel>
    );

    renderRGBPictoSection = () => (
        <Panel
            className="panel-small"
            shaded
            bordered
            header={
                <PanelHeader
                    title={this.props.intl.formatMessage({
                        id: 'ipCanDevices.lpDisplay.virtualDisplay.steps.create.pictoPart',
                    })}
                    buttons={[]}
                />
            }>
            {/* === PICTO STYLE === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.picto" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            name="picto"
                            data-cy="lpDisplay-add-step-rgb-picto"
                            accepter={SelectPicker}
                            data={LPVirtualDisplayRGBPicto()}
                            placement="top"
                            searchable={false}
                            cleanable={false}
                            disabledItemValues={this.state.formValue.mode === 2 ? [0] : []}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>

            {/* === PICTO POSITION === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.pictoPosition" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            data-cy="lpDisplay-add-step-pictoPosition"
                            name="pictoPosition"
                            accepter={SelectPicker}
                            data={LPVirtualDisplayPosition(this.props.intl)}
                            searchable={false}
                            cleanable={false}
                            disabled={this.state.formValue.picto === 0}
                            placement="top"
                            renderMenuItem={(label, item) => {
                                return <div data-cy={`lpDisplay-add-step-pictoPosition-${item.value}`}>{label}</div>;
                            }}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>
        </Panel>
    );

    renderPictoSection = () => (
        <Panel
            className="panel-small"
            shaded
            bordered
            header={
                <PanelHeader
                    title={this.props.intl.formatMessage({
                        id: 'ipCanDevices.lpDisplay.virtualDisplay.steps.create.pictoPart',
                    })}
                    buttons={[]}
                />
            }>
            {/* === PICTO STYLE === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.picto" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            name="picto"
                            data-cy="lpDisplay-add-step-picto"
                            accepter={SelectPicker}
                            data={LPVirtualDisplayPicto(this.props.intl)}
                            renderMenuItem={label => (
                                <div data-cy="lpDisplay-add-step-picto-number">
                                    <FlexboxGrid>
                                        <FlexboxGrid.Item style={{ height: 20, width: 20 }}>{label}</FlexboxGrid.Item>
                                    </FlexboxGrid>
                                </div>
                            )}
                            renderValue={(_, item: any) => (
                                <div>
                                    <FlexboxGrid>
                                        <FlexboxGrid.Item style={{ height: 20, width: 20 }}>
                                            {item.label}
                                        </FlexboxGrid.Item>
                                    </FlexboxGrid>
                                </div>
                            )}
                            placement="top"
                            searchable={false}
                            cleanable={false}
                            disabledItemValues={this.state.formValue.mode === 2 ? [0] : []}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>

            {/* === PICTO SIZE === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.pictoSize" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            data-cy="lpDisplay-add-step-pictoSize"
                            name="pictoSize"
                            accepter={SelectPicker}
                            data={LPVirtualDisplaySize(this.props.intl)}
                            searchable={false}
                            cleanable={false}
                            disabled={this.state.formValue.picto === 0}
                            placement="top"
                            renderMenuItem={(label, item) => {
                                return <div data-cy={`lpDisplay-add-step-pictoSize-${item.value}`}>{label}</div>;
                            }}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>

            {/* === PICTO POSITION === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.pictoPosition" />
                        </ControlLabel>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            data-cy="lpDisplay-add-step-pictoPosition"
                            name="pictoPosition"
                            accepter={SelectPicker}
                            data={LPVirtualDisplayPosition(this.props.intl)}
                            searchable={false}
                            cleanable={false}
                            disabled={this.state.formValue.picto === 0}
                            disabledItemValues={this.state.formValue.mode !== 2 ? [0] : []}
                            placement="top"
                            renderMenuItem={(label, item) => {
                                return <div data-cy={`lpDisplay-add-step-pictoPosition-${item.value}`}>{label}</div>;
                            }}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>
        </Panel>
    );

    renderTextSection = () => (
        <Panel
            className="panel-small"
            shaded
            bordered
            header={
                <PanelHeader
                    title={this.props.intl.formatMessage({
                        id: 'ipCanDevices.lpDisplay.virtualDisplay.steps.create.textPart',
                    })}
                    buttons={[]}
                />
            }>
            {/* === TEXT TRANSFORMATION === */}
            <FormGroup>
                <FlexboxGrid align="middle" justify="space-between">
                    <FlexboxGrid.Item componentClass={Col} xs={10}>
                        <ControlLabel>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.textTransformation" />
                        </ControlLabel>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item componentClass={Col} xs={12}>
                        <FormControl
                            data-cy="lpDisplay-virtualDisplay-textTransformation"
                            name="textTransformation"
                            accepter={SelectPicker}
                            data={LPVirtualDisplayTextTransformation(this.props.intl)}
                            searchable={false}
                            cleanable={false}
                            placement="top"
                            renderMenuItem={(label, item) => {
                                return (
                                    <div data-cy={`lpDisplay-virtualDisplay-step-textTransformation-${item.value}`}>
                                        {label}
                                    </div>
                                );
                            }}
                        />
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </FormGroup>
        </Panel>
    );

    renderTriggerMin = () => {
        return (
            <Panel
                className="panel-small"
                shaded
                bordered
                header={
                    <PanelHeader
                        title={this.props.intl.formatMessage({
                            id: 'ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMin',
                        })}
                        buttons={[]}
                    />
                }>
                {/* === TRIGGER MIN TYPE === */}
                <FormGroup>
                    <FlexboxGrid align="middle" justify="space-between">
                        <FlexboxGrid.Item componentClass={Col} xs={10}>
                            <ControlLabel>
                                <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMinType" />
                            </ControlLabel>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item componentClass={Col} xs={12}>
                            <FormControl
                                data-cy="lpDisplay-add-step-triggerMinType"
                                name="triggerMinType"
                                accepter={SelectPicker}
                                data={LPVirtualDisplayTriggerType(this.props.intl)}
                                searchable={false}
                                cleanable={false}
                                placement="auto"
                                renderMenuItem={(label, item) => {
                                    return (
                                        <div data-cy={`lpDisplay-virtualDisplay-step-triggerMinType-${item.value}`}>
                                            {label}
                                        </div>
                                    );
                                }}
                            />
                        </FlexboxGrid.Item>
                    </FlexboxGrid>
                </FormGroup>

                {this.state.formValue.triggerMinType === 0 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMinAction" />
                                </ControlLabel>
                            </FlexboxGrid.Item>

                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl
                                    data-cy="lpDisplay-add-step-triggerMinAction"
                                    name="triggerMinAction"
                                    accepter={SelectPicker}
                                    data={LPVirtualDisplayTriggerSteps(this.props.intl, this.props.virtualDisplay)}
                                    searchable={false}
                                    cleanable={false}
                                    placement="auto"
                                    renderMenuItem={(label, item) => {
                                        return (
                                            <div
                                                data-cy={`lpDisplay-virtualDisplay-step-triggerMinAction-${item.value}`}>
                                                {label}
                                            </div>
                                        );
                                    }}
                                />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}

                {this.state.formValue.triggerMinType === 100 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMinAction" />
                                </ControlLabel>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl
                                    data-cy="lpDisplay-add-step-triggerMinAction"
                                    name="triggerMinAction"
                                    accepter={SelectPicker}
                                    data={LPVirtualDisplayTriggerVirtualDisplay(
                                        this.props.intl,
                                        this.props.display.getPreviewInformation()
                                    )}
                                    searchable={false}
                                    cleanable={false}
                                    placement="auto"
                                    renderMenuItem={(label, item) => {
                                        return (
                                            <div
                                                data-cy={`lpDisplay-virtualDisplay-step-triggerMinAction-${item.value}`}>
                                                {label}
                                            </div>
                                        );
                                    }}
                                />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}

                {this.state.formValue.triggerMinType === 1000 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMinAction" />
                                </ControlLabel>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl
                                    data-cy="lpDisplay-add-step-triggerMinAction"
                                    name="triggerMinAction"
                                    accepter={SelectPicker}
                                    data={LPVirtualDisplaySystemText(this.props.intl)}
                                    searchable={false}
                                    cleanable={false}
                                    placement="auto"
                                    renderMenuItem={(label, item) => {
                                        return (
                                            <div
                                                data-cy={`lpDisplay-virtualDisplay-step-triggerMinAction-${item.value}`}>
                                                {label}
                                            </div>
                                        );
                                    }}
                                />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}

                {this.state.formValue.triggerMinType === 2000 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMinAction" />
                                </ControlLabel>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl
                                    data-cy="lpDisplay-add-step-triggerMinAction"
                                    name="triggerMinAction"
                                    accepter={SelectPicker}
                                    data={LPVirtualDisplayUserText(this.props.display.getTextConfig().getUserText())}
                                    searchable={false}
                                    cleanable={false}
                                    placement="auto"
                                    renderMenuItem={(label, item) => {
                                        return (
                                            <div
                                                data-cy={`lpDisplay-virtualDisplay-step-triggerMinAction-${item.value}`}>
                                                {label}
                                            </div>
                                        );
                                    }}
                                />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}

                {this.state.formValue.triggerMinType !== -1 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMinValue" />
                                </ControlLabel>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl name="triggerMinValue" accepter={Input} type="number" />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}
            </Panel>
        );
    };

    renderTriggerMax = () => {
        return (
            <Panel
                className="panel-small"
                shaded
                bordered
                header={
                    <PanelHeader
                        title={this.props.intl.formatMessage({
                            id: 'ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMax',
                        })}
                        buttons={[]}
                    />
                }>
                {/* === TRIGGER MAX TYPE === */}
                <FormGroup>
                    <FlexboxGrid align="middle" justify="space-between">
                        <FlexboxGrid.Item componentClass={Col} xs={10}>
                            <ControlLabel>
                                <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMaxType" />
                            </ControlLabel>
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item componentClass={Col} xs={12}>
                            <FormControl
                                data-cy="lpDisplay-add-step-triggerMaxType"
                                name="triggerMaxType"
                                accepter={SelectPicker}
                                data={LPVirtualDisplayTriggerType(this.props.intl)}
                                searchable={false}
                                cleanable={false}
                                renderMenuItem={(label, item) => {
                                    return (
                                        <div data-cy={`lpDisplay-virtualDisplay-step-triggerMaxType-${item.value}`}>
                                            {label}
                                        </div>
                                    );
                                }}
                            />
                        </FlexboxGrid.Item>
                    </FlexboxGrid>
                </FormGroup>

                {this.state.formValue.triggerMaxType === 0 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMaxAction" />
                                </ControlLabel>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl
                                    data-cy="lpDisplay-add-step-triggerMaxAction"
                                    name="triggerMaxAction"
                                    accepter={SelectPicker}
                                    data={LPVirtualDisplayTriggerSteps(this.props.intl, this.props.virtualDisplay)}
                                    searchable={false}
                                    cleanable={false}
                                    placement="auto"
                                    renderMenuItem={(label, item) => {
                                        return (
                                            <div
                                                data-cy={`lpDisplay-virtualDisplay-step-triggerMaxAction-${item.value}`}>
                                                {label}
                                            </div>
                                        );
                                    }}
                                />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}

                {this.state.formValue.triggerMaxType === 100 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMaxAction" />
                                </ControlLabel>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl
                                    data-cy="lpDisplay-add-step-triggerMaxAction"
                                    name="triggerMaxAction"
                                    accepter={SelectPicker}
                                    data={LPVirtualDisplayTriggerVirtualDisplay(
                                        this.props.intl,
                                        this.props.display.getPreviewInformation()
                                    )}
                                    searchable={false}
                                    cleanable={false}
                                    placement="auto"
                                    renderMenuItem={(label, item) => {
                                        return (
                                            <div
                                                data-cy={`lpDisplay-virtualDisplay-step-triggerMaxAction-${item.value}`}>
                                                {label}
                                            </div>
                                        );
                                    }}
                                />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}

                {this.state.formValue.triggerMaxType === 1000 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMaxAction" />
                                </ControlLabel>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl
                                    data-cy="lpDisplay-add-step-triggerMaxAction"
                                    name="triggerMaxAction"
                                    accepter={SelectPicker}
                                    data={LPVirtualDisplaySystemText(this.props.intl)}
                                    searchable={false}
                                    cleanable={false}
                                    placement="auto"
                                    renderMenuItem={(label, item) => {
                                        return (
                                            <div
                                                data-cy={`lpDisplay-virtualDisplay-step-triggerMaxAction-${item.value}`}>
                                                {label}
                                            </div>
                                        );
                                    }}
                                />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}

                {this.state.formValue.triggerMaxType === 2000 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMaxAction" />
                                </ControlLabel>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl
                                    data-cy="lpDisplay-add-step-triggerMaxAction"
                                    name="triggerMaxAction"
                                    accepter={SelectPicker}
                                    data={LPVirtualDisplayUserText(this.props.display.getTextConfig().getUserText())}
                                    searchable={false}
                                    cleanable={false}
                                    placement="auto"
                                    renderMenuItem={(label, item) => {
                                        return (
                                            <div
                                                data-cy={`lpDisplay-virtualDisplay-step-triggerMaxAction-${item.value}`}>
                                                {label}
                                            </div>
                                        );
                                    }}
                                />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}

                {this.state.formValue.triggerMaxType !== -1 && (
                    <FormGroup>
                        <FlexboxGrid align="middle" justify="space-between">
                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                <ControlLabel>
                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.triggerMaxValue" />
                                </ControlLabel>
                            </FlexboxGrid.Item>
                            <FlexboxGrid.Item componentClass={Col} xs={12}>
                                <FormControl name="triggerMaxValue" accepter={Input} type="number" />
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </FormGroup>
                )}
            </Panel>
        );
    };

    render = () => {
        const mode = this.state.formValue.mode;
        const shouldShowArrowPart =
            mode === 1 || (mode >= 101 && mode <= 132) || (mode >= 201 && mode <= 232) || (mode >= 301 && mode <= 308);
        const shouldShowPictoPart =
            mode === 2 || (mode >= 101 && mode <= 132) || (mode >= 201 && mode <= 232) || (mode >= 301 && mode <= 308);
        const shouldShowRGBPictoPart = mode === 20;
        const shouldShowTextPart = (mode >= 101 && mode <= 308) || (mode >= 5 && mode <= 7);
        const shouldShowCounterPart = mode >= 101 && mode <= 132;

        return (
            <>
                <EditUserTextModal
                    display={this.props.display}
                    editUserInformation={this.state.editUserTextModalInformation}
                    onHide={() => this.setState({ editUserTextModalInformation: { isOpen: false, userTextIndex: -1 } })}
                />
                <Modal show={this.props.show} onHide={() => this.hideModal(false)} backdrop="static">
                    <Modal.Header>
                        <Modal.Title>
                            <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create" />
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form fluid onChange={this.handleFormChange} formValue={this.state.formValue}>
                            <FlexboxGrid justify="center" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                <FlexboxGrid.Item className="margin-bottom-10">
                                    <LPMatrixDisplayWidget
                                        display={this.props.display}
                                        backgroundColor={this.props.virtualDisplay.backgroundColor}
                                        step={this.state.previewStep}
                                    />
                                </FlexboxGrid.Item>
                            </FlexboxGrid>

                            <Panel
                                className="panel-small"
                                shaded
                                bordered
                                header={
                                    <PanelHeader
                                        title={this.props.intl.formatMessage({
                                            id: 'ipCanDevices.lpDisplay.virtualDisplay.steps.create.configuration',
                                        })}
                                        buttons={[]}
                                    />
                                }>
                                {/* === STATE === */}
                                <FormGroup>
                                    <FlexboxGrid align="middle" justify="space-between">
                                        <FlexboxGrid.Item componentClass={Col} xs={10}>
                                            <ControlLabel>
                                                <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.state" />
                                            </ControlLabel>
                                        </FlexboxGrid.Item>

                                        <FlexboxGrid.Item componentClass={Col} xs={12}>
                                            <FormControl
                                                data-cy="virtualDisplay-step-state"
                                                name="state"
                                                accepter={SelectPicker}
                                                data={LPVirtualDisplayStateFormValues(this.props.intl)}
                                                searchable={false}
                                                cleanable={false}
                                                renderMenuItem={(label, item) => {
                                                    return (
                                                        <div data-cy={`virtualDisplay-step-state-${item.value}`}>
                                                            {label}
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </FlexboxGrid.Item>
                                    </FlexboxGrid>
                                </FormGroup>

                                {/* === COLOR === */}
                                {mode !== 20 && (
                                    <FormGroup>
                                        <FlexboxGrid align="middle" justify="space-between">
                                            <FlexboxGrid.Item componentClass={Col} xs={10}>
                                                <ControlLabel>
                                                    <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.color" />
                                                </ControlLabel>
                                            </FlexboxGrid.Item>

                                            <FlexboxGrid.Item
                                                componentClass={Col}
                                                xs={12}
                                                className="padding-top-5 padding-bottom-5">
                                                <CompactPicker
                                                    colors={LPVirtualDisplayStepColor()}
                                                    color={this.state.formValue.color}
                                                    onChangeComplete={this.handleColorChange}
                                                />
                                            </FlexboxGrid.Item>
                                        </FlexboxGrid>
                                    </FormGroup>
                                )}

                                {/* === MODE === */}
                                <FormGroup>
                                    <FlexboxGrid align="middle" justify="space-between">
                                        <FlexboxGrid.Item componentClass={Col} xs={12}>
                                            <ControlLabel>
                                                <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.mode" />
                                            </ControlLabel>
                                        </FlexboxGrid.Item>

                                        <FlexboxGrid.Item
                                            componentClass={Col}
                                            xs={
                                                this.state.formValue.mode >= 301 && this.state.formValue.mode <= 308
                                                    ? 10
                                                    : 12
                                            }>
                                            <FormControl
                                                data-cy="lpDisplay-add-step-mode"
                                                name="mode"
                                                accepter={SelectPicker}
                                                data={LPVirtualDisplayMode(
                                                    this.props.intl,
                                                    this.props.display.getPreviewInformation()
                                                )}
                                                searchable={false}
                                                cleanable={false}
                                                renderMenuItem={(label, item) => {
                                                    return (
                                                        <div data-cy={`lpDisplay-add-step-mode-${item.value}`}>
                                                            {label}
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </FlexboxGrid.Item>

                                        {this.state.formValue.mode >= 301 && this.state.formValue.mode <= 308 && (
                                            <FlexboxGrid.Item componentClass={Col} xs={2}>
                                                <Button
                                                    appearance="link"
                                                    onClick={() =>
                                                        this.setState({
                                                            editUserTextModalInformation: {
                                                                isOpen: true,
                                                                userTextIndex: this.state.formValue.mode - 301,
                                                            },
                                                        })
                                                    }>
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </Button>
                                            </FlexboxGrid.Item>
                                        )}
                                    </FlexboxGrid>
                                </FormGroup>

                                {/* === TIME === */}
                                <FormGroup>
                                    <FlexboxGrid align="middle" justify="space-between">
                                        <FlexboxGrid.Item componentClass={Col} xs={10}>
                                            <ControlLabel>
                                                <FormattedMessage id="ipCanDevices.lpDisplay.virtualDisplay.steps.create.time" />
                                            </ControlLabel>
                                        </FlexboxGrid.Item>

                                        <FlexboxGrid.Item componentClass={Col} xs={12}>
                                            <FormControl
                                                data-cy="lpDisplay-add-step-time"
                                                name="time"
                                                min={0}
                                                type="number"
                                            />
                                        </FlexboxGrid.Item>
                                    </FlexboxGrid>
                                </FormGroup>
                            </Panel>

                            {shouldShowArrowPart && this.renderArrowSection()}
                            {shouldShowPictoPart && this.renderPictoSection()}

                            {shouldShowRGBPictoPart && this.renderRGBPictoSection()}

                            {shouldShowTextPart && this.renderTextSection()}

                            {shouldShowCounterPart && this.renderTriggerMin()}
                            {shouldShowCounterPart && this.renderTriggerMax()}
                        </Form>
                    </Modal.Body>

                    <Modal.Footer className="margin-top-10">
                        <FlexboxGrid align="middle" justify="end">
                            <FlexboxGrid.Item>
                                <ButtonGroup>
                                    <Button
                                        data-cy="lpDisplay-add-step-cancel"
                                        onClick={() => this.hideModal()}
                                        color="red"
                                        disabled={this.state.isCreating}>
                                        <FontAwesomeIcon icon={faTimesCircle} />
                                    </Button>
                                    <Button
                                        data-cy="lpDisplay-add-step-valid"
                                        onClick={this.createStep}
                                        appearance="primary"
                                        loading={this.state.isCreating}>
                                        <FontAwesomeIcon icon={faCheck} />
                                    </Button>
                                </ButtonGroup>
                            </FlexboxGrid.Item>
                        </FlexboxGrid>
                    </Modal.Footer>
                </Modal>
            </>
        );
    };
}

export default injectIntl(CreateLPVirtualDisplayStepModal);
